var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.561 32H19.8171C19.2627 31.792 19.0681 31.3868 19.0708 30.8083C19.0841 28.4249 19.0708 26.0441 19.0708 23.6607C19.0708 22.5943 18.4231 21.9571 17.3569 21.9544H14.6916C13.5374 21.9544 12.9137 22.5729 12.9137 23.722C12.9137 26.0814 12.9137 28.4435 12.9137 30.8056C12.9137 31.3842 12.7245 31.792 12.1701 32H6.44221C6.41838 31.9804 6.39133 31.9651 6.36225 31.9547C5.51781 31.8178 4.75293 31.3757 4.21256 30.7124C3.67219 30.049 3.39386 29.2105 3.43034 28.3556C3.47298 25.3483 3.43034 22.3383 3.43034 19.3284V18.9791C3.39814 18.9657 3.36521 18.9542 3.33172 18.9445C3.17446 18.9445 3.01987 18.9445 2.86261 18.9445C2.33386 18.937 1.81743 18.7836 1.37019 18.5014C0.92296 18.2192 0.562264 17.819 0.327836 17.3448C0.198763 17.053 0.0892465 16.7528 0 16.4464V15.5719C0.189242 14.6362 0.799614 13.9723 1.44197 13.3351C5.55376 9.24723 9.65666 5.14777 13.7507 1.03675C15.134 -0.344251 16.8612 -0.346917 18.2445 1.03675L30.9664 13.7617C31.0756 13.871 31.1876 13.983 31.2889 14.1003C31.6258 14.4913 31.8536 14.9643 31.9492 15.4716C32.0449 15.9788 32.0049 16.5024 31.8335 16.9893C31.662 17.4762 31.3651 17.9092 30.9728 18.2445C30.5804 18.5799 30.1066 18.8057 29.599 18.8991C29.2562 18.9478 28.9109 18.9781 28.5648 18.9898V19.3737C28.5648 22.4769 28.5648 25.5802 28.5648 28.6835C28.547 29.4088 28.299 30.1096 27.8568 30.6847C27.4146 31.2598 26.801 31.6794 26.1047 31.8827C25.9234 31.9094 25.7449 31.952 25.561 32Z",
    fill: "url(#paint0_linear_580_817)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_580_817",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA520"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/homeIcon.4a6a4314985837fd1c3762c51dac2648.svg";
export { ForwardRef as ReactComponent };